import { render, staticRenderFns } from "./TaskSummaryHorizontalBarChartWidget.vue?vue&type=template&id=b2ae10bc&"
import script from "./TaskSummaryHorizontalBarChartWidget.vue?vue&type=script&lang=js&"
export * from "./TaskSummaryHorizontalBarChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports